export default {
    methods: {
      gridChange(measurerList, id) {
        // id here is groups.indexOf(group) in caller
        const ref = this.$refs[`Group-${id}`];
        if (ref && ref[0] && typeof ref[0].gridChange === 'function') {
          ref[0].gridChange(measurerList);
        }
      },
      async updatePosition() {
        this.refreshGrid = true;
        await this.$nextTick();
        this.refreshGrid = false;
      },
    },
  };
  